import { initIntersectionObserver } from "@plugins";

const instructionsBlock = document.querySelector(".js-product-page-card-instructions-block");

if (instructionsBlock) {
    initIntersectionObserver(instructionsBlock, initInstructionsBlock);
}

function initInstructionsBlock(block) {
    const showAllInstructionsBtn = block.querySelector(".js-product-page-card-instructions-btn");
    const instructionsList = block.querySelector(".js-product-page-card-instructions-list");

    if (instructionsList) {
        const instructionsItems = instructionsList.querySelectorAll(
            ".js-product-page-card-instruction-item",
        );

        if (instructionsItems && instructionsItems.length > 2) {
            block.classList.add("initialized");

            hideInstructionsItems(block);

            if (showAllInstructionsBtn) {
                showAllInstructionsBtn.addEventListener("click", () => {
                    block.style.height = `${block.offsetHeight}px`;

                    if (block.classList.contains("closed")) {
                        block.classList.remove("closed");

                        for (let i = 2; i < instructionsItems.length; i++) {
                            instructionsItems[i].classList.remove("hidden");
                        }
                    } else {
                        hideInstructionsItems(block);
                    }
                });
            }
        } else {
            block.classList.add("default-state");
        }
    }
}

function hideInstructionsItems(block) {
    const instructionsItems = block.querySelectorAll(".js-product-page-card-instruction-item");

    block.classList.add("closed");

    for (let i = 2; i < instructionsItems.length; i++) {
        instructionsItems[i].classList.add("hidden");
    }
}
